import { EditableTextbox } from "@/overlay/components/CommonParts/EditableTextbox";
import { CrossSectionActionPanel } from "@/overlay/components/LayerStackWindow/CrossSectionActionPanel";
import * as windowManager from "@/overlay/components/window";
import { useAppDispatch } from "@/reducer";
import { setCrossSectionTitle } from "@/reducer/CrossSectionState";
import { t } from "@lingui/core/macro";
import type { CrossSectionSchemaOutput } from "@mm/metx-workbench.meteomatics.com";

type CrossSectionSettingsProps = {
  crossSection: CrossSectionSchemaOutput;
  clearCrossSection: () => void;
};

export function CrossSectionSettings({ crossSection, clearCrossSection }: CrossSectionSettingsProps) {
  const dispatch = useAppDispatch();

  return (
    <windowManager.WindowSection>
      <div className="title-row">
        <EditableTextbox
          className={"editable-map-title"}
          value={crossSection.title ?? ""}
          placeholder={crossSection.title === "" ? t`Untitled Cross Section` : undefined}
          blurOnEnterKey
          onSave={(newTitle) => {
            dispatch(
              setCrossSectionTitle({
                id: crossSection.id,
                title: newTitle,
              }),
            );
          }}
        />
        <CrossSectionActionPanel clearCrossSection={clearCrossSection} />
      </div>

      <div className="cross-section-settings" />
    </windowManager.WindowSection>
  );
}
